import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import "./Home.css";

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition =
        window.scrollY || document.documentElement.scrollTop;

      const scrollThreshold = 1;

      if (scrollPosition > scrollThreshold) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="homepage">
      <div className={`mainTitleContainer ${isVisible ? "notVisible" : ""}`}>
        <h1 id="mainTitle">
          hiragana<span className="dot">.</span>se
        </h1>

        <img
          className="scrollDownIcon"
          src="https://img.icons8.com/ios/50/circled-chevron-right--v1.png"
          alt="Open/close"
        />
      </div>

      <div className={`headerContainer ${isVisible ? "visible" : ""}`}>
        <Header />
      </div>
      <div className="contContainer">
        <div className="restContainer">
          <div className={`infoBox ${isVisible ? "visible" : ""}`}>
            <h2>
              Är du intresserad av japanska?
              <br />
              På hiragana.se hittar du de verktyg du behöver för att lära dig de
              grundläggande stegen att lära dig läsa och skriva.
            </h2>
          </div>
          <div className={`infoBox ${isVisible ? "visible" : ""}`}>
            <h2>
              Hiragana är ett av de tre skriftsystemen som används i japanska
              och består av tecken där var och en representerar en stavelse, och
              används för grammatiska ändelser, partiklar och ord utan
              kanji-representation. Det går även att skriva all japansk text
              enbart med hiragana, utan kanji.
              <br />
              Tecknen ordnas traditionellt i en rutnätstabell kallad gōjuon(
              <span style={{ fontFamily: "Arial", fontSize: "1.5rem" }}>
                五十音,
              </span>
              "femtio ljud"), där rader och kolumner organiseras efter vokal-
              och konsonantljud.
              <br />
              För att transkribera hiragana används vad som på japanska kallas
              <span style={{ fontStyle: "italic" }}> rōmaji</span>, det vill
              säga det latinska alfabetet. Vad som är viktigt att komma ihåg är
              att rōmaji är konstruerat ur ett engelsktalande perspektiv.
            </h2>
          </div>
          <div className={`infoBox ${isVisible ? "visible" : ""}`}>
            <h2>
              Katakana delar samma ljud och antal tecken som hiragana, men
              används främst för lånord och utländska namn.
            </h2>
          </div>
          <div className={`infoBox ${isVisible ? "visible" : ""}`}>
            <h2>
              Kanji skiljer sig från de båda genom att vara logografiska tecken
              där varje tecken representerar ett ord snarare än ett ljud.
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
